export const state = {
    perfil: {},
    perfis: [],
    perfilPermissoesSelecionadas: [],
    modalExcluirPerfil: false,
    modalCadastrarPerfil: false,
}

export default {}